module.exports = __webpack_public_path__ + "img/3.6d7377d0.jpg";